import { Box, Button, Flex, Image, Separator, Stack, Text } from "@chakra-ui/react";

import Map from "@/components/general/Map";
import MarkerFicha from "@/components/general/MarkerFicha";

const Location = ({ dataDevelopment, isGreaterThanMd }) => {
    let marker = {
        position: {
            lat: dataDevelopment?.location_props
                ? parseFloat(dataDevelopment?.location_props?.latitude)
                : dataDevelopment?.latitude,
            lng: dataDevelopment?.location_props
                ? parseFloat(dataDevelopment?.location_props?.longitude)
                : dataDevelopment?.longitude,
        },
        title: dataDevelopment?.name,
    };

    return (
        <Box bg="white" rounded="md" h="100%" py={4}>
            <Text fontWeight={700} fontSize="md">
                Ubicación
            </Text>
            <Box display="flex" flexDirection={{ base: "column", md: "row" }} alignItems="end">
                <Text fontWeight={400} fontSize="sm" lineClamp={2} my={{ base: 3, md: 0 }}>
                    {dataDevelopment?.location_props?.street_name
                        ? dataDevelopment?.location_props?.street_name + " "
                        : "Unamed Road "}
                    {dataDevelopment?.location_props?.exterior_number &&
                    dataDevelopment?.location_props?.exterior_number !== "n/a"
                        ? "#" + dataDevelopment?.location_props?.exterior_number + ""
                        : ""}
                    {dataDevelopment?.location_props?.internal_number
                        ? " " + dataDevelopment?.location_props?.internal_number + ", "
                        : ", "}
                    {dataDevelopment?.location_props?.postal_code
                        ? "CP. " + dataDevelopment?.location_props?.postal_code + ", "
                        : " "}
                    {dataDevelopment?.location_props?.city
                        ? dataDevelopment?.location_props?.city + ", "
                        : ""}
                    {dataDevelopment?.location_props?.province
                        ? dataDevelopment?.location_props?.province + ", "
                        : ""}
                    {dataDevelopment?.location_props?.country
                        ? dataDevelopment?.location_props?.country + "."
                        : "."}
                </Text>
                <Flex
                    w={{ base: "100%", md: "fit-content" }}
                    ml={{ md: "auto" }}
                    gap={2}
                    mt={{ base: 2, md: 0 }}
                >
                    <Button
                        minW={{ base: "55%", md: "50px" }}
                        fontSize="sm"
                        bg="transparent"
                        borderColor="#B8B8B8"
                        borderWidth="1px"
                        borderRadius="lg"
                        _hover={{ background: "#F0F0F0" }}
                        px={5}
                        color="black"
                        onClick={() =>
                            window.open(
                                `https://www.google.com/maps/dir/?api=1&destination=${marker?.position?.lat},${marker?.position?.lng}`,
                                "_blank"
                            )
                        }
                    >
                        <Image
                            src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/fichas/maps.svg"
                            alt="map_icon"
                            mr={2}
                            w={6}
                        />
                        Google Maps
                    </Button>
                    <Button
                        minW={{ base: "40%", md: "50px" }}
                        fontSize="sm"
                        bg="transparent"
                        borderColor="#B8B8B8"
                        borderWidth="1px"
                        borderRadius="lg"
                        _hover={{ background: "#F0F0F0" }}
                        px={5}
                        color="black"
                        onClick={() =>
                            window.open(
                                `https://www.waze.com/es/live-map/directions?navigate=yes&to=ll.${marker?.position?.lat}%2C${marker?.position?.lng}`,
                                "_blank"
                            )
                        }
                    >
                        <Image
                            src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/fichas/waze.svg"
                            alt="waze_icon"
                            mr={2}
                            w={6}
                        />
                        Waze
                    </Button>
                </Flex>
            </Box>
            <Stack
                direction="row"
                align="center"
                h="400px"
                placeSelf="center"
                my={7}
                maxW="100%"
                minW="100%"
            >
                <Map zoom={14} center={marker.position} fullWidth={false}>
                    <MarkerFicha marker={marker} />
                </Map>
            </Stack>
            <Flex gap={5} pt={5} mb={10} flexDirection="column" alignItems="center">
                {dataDevelopment?.extra_props?.has_sales_office === "true" &&
                    dataDevelopment?.extra_props?.sales_schedule && (
                        <Box
                            bg="#E3E3E3"
                            borderWidth={1}
                            borderRadius="lg"
                            borderColor="#A5A5A5"
                            p={3}
                            display="flex"
                            gap={3}
                            alignItems="center"
                            w="fit-content"
                        >
                            <Image
                                src="https://media.grupoguia.mx/assets/apps-icons/office_icon.svg"
                                alt="office_icon"
                                maxH="30px"
                            />
                            <Text fontSize="sm">
                                <strong>Horario de oficina de ventas: </strong>{" "}
                                {!isGreaterThanMd ? <br /> : ""}{" "}
                                {dataDevelopment?.extra_props?.sales_schedule}
                            </Text>
                        </Box>
                    )}
                {dataDevelopment?.extra_props?.has_sample_apartment === "true" && (
                    <Box
                        bg="#E3E3E3"
                        borderWidth={1}
                        borderRadius="lg"
                        borderColor="#A5A5A5"
                        p={3}
                        display="flex"
                        gap={3}
                        alignItems="center"
                        w="fit-content"
                    >
                        <Image
                            src="https://media.grupoguia.mx/assets/apps-icons/plain_icon.svg"
                            alt="plain_icon"
                            maxH="30px"
                        />
                        <Text fontSize="sm">
                            <strong>Departamento muestra: </strong> Si
                        </Text>
                    </Box>
                )}
            </Flex>
            <Separator borderColor="#B1B1B1" />
        </Box>
    );
};

export default Location;
